import React from 'react';

type Props = {
  color?: string,
} & typeof defaultProps;

const defaultProps = {
  color: '#fff',
};

const AddPlusIcon = function AddPlusIcon(props: Props) {
  const { color } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" className="add-plus-icon">
      <path d="M5.44453 -0.000232697V5.4443H0L0 8.55547H5.44453V14H8.5557V8.55547H14.0002V5.4443H8.5557V-0.000232697H5.44453Z" fill={color} />
    </svg>

  );
};
AddPlusIcon.defaultProps = defaultProps;
export default AddPlusIcon;
